import { render, staticRenderFns } from "./NvDiscover.vue?vue&type=template&id=367fb099&scoped=true&"
import script from "./NvDiscover.vue?vue&type=script&lang=js&"
export * from "./NvDiscover.vue?vue&type=script&lang=js&"
import style0 from "./NvDiscover.vue?vue&type=style&index=0&id=367fb099&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367fb099",
  null
  
)

export default component.exports